// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionPreviewBlock_container__T9vh4","img":"SubscriptionPreviewBlock_img__mHBSN"};